import type { OPS_EVENTS } from '@nx/analytics-service';
import { APP_SCOPE } from '@nx/constants';
import { StoreKit, trackEvent } from '@nx/state';

export const track = (event: OPS_EVENTS, properties?: Record<string, unknown>) => {
  const { globalStore } = StoreKit.UNSAFE_getGlobalStoreInstance();
  return globalStore.dispatch(trackEvent({ event, properties, scope: APP_SCOPE.ops }));
};
